import React, { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { api } from "../../lib/api";

let cached = null;

export const usePlatformStatus = () => {
  const [status, setStatus] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api
      .get("/platform-status")
      .then((r) => {
        cached = r.data;
        setStatus(r.data);
      })
      .catch((e) => console.error("Could not read platform status", e));
  }, []);
  return status;
};

/** Honest, self-removing notice for the parts of PostMint that still run in test mode. */
export const BetaNotice = ({ kind, testId }) => {
  const status = usePlatformStatus();
  if (!status) return null;
  if (kind === "publishing" && !status.publishing_simulated) return null;
  if (kind === "payments" && !status.payments_test_mode) return null;

  const body =
    kind === "publishing"
      ? "Publishing runs in simulated mode while our Instagram, Facebook, LinkedIn and TikTok app access is being reviewed. Your approvals, timings and queue all work exactly as they will live — posts are marked as published here, but nothing is sent to the platforms yet. You'll be told the moment that changes."
      : "Payments run on Stripe's test environment during the beta, so you can walk through checkout with the test card without being charged. No real money moves until we switch to live payments.";

  return (
    <div
      className="flex gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4"
      data-testid={testId || `beta-notice-${kind}`}
    >
      <FlaskConical className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" aria-hidden="true" />
      <div>
        <p className="text-sm font-semibold text-amber-900">
          {kind === "publishing" ? "Simulated publishing (beta)" : "Test payments (beta)"}
        </p>
        <p className="mt-1 text-sm leading-relaxed text-amber-900/85">{body}</p>
      </div>
    </div>
  );
};

export default BetaNotice;
